
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/join-the-team",
      function () {
        return require("private-next-pages/join-the-team.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/join-the-team"])
      });
    }
  